var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M92.903,96.403c-0.935,0-1.813-0.364-2.475-1.025L66.346,71.295c-6.856,5.716-15.492,8.849-24.476,8.849   c-10.223,0-19.834-3.981-27.063-11.21C7.578,61.705,3.597,52.093,3.597,41.87c0-10.224,3.981-19.835,11.211-27.063   c7.229-7.229,16.84-11.21,27.063-11.21s19.834,3.981,27.063,11.211c14.043,14.042,14.971,36.411,2.36,51.537l24.084,24.084   c0.661,0.661,1.025,1.54,1.025,2.475s-0.364,1.814-1.025,2.475C94.717,96.039,93.838,96.403,92.903,96.403z M41.87,10.597   c-8.353,0-16.206,3.253-22.113,9.16s-9.16,13.76-9.16,22.113s3.253,16.207,9.16,22.114c5.906,5.907,13.76,9.16,22.113,9.16   s16.207-3.253,22.114-9.16c5.896-5.897,9.145-13.751,9.145-22.114c0-8.364-3.248-16.217-9.145-22.113   C58.077,13.85,50.224,10.597,41.87,10.597z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.3117da249690c5e5be1386c5e768aeeb.svg";
export { ForwardRef as ReactComponent };